(function () {
  'use strict';

  console.log('Stock Checker: Script loading...');

  // API Configuration
  const API_CONFIG = {
    BEARER_TOKEN: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkFsZXggS2ltIiwiaWF0IjoxMzQ1MzIzfQ.fLnUbfoEZZSKlM4H4lCECH2CelyIeQ8uOufmccWctaA',
    REGIONS_URL: 'https://stores.batteryvape.com/api/regions',
    STOCK_BY_REGION_URL: 'https://freshdesk.jd.net.nz/live-stock',
    STOCK_BY_LOCATION_URL: 'https://freshdesk.jd.net.nz/live-stock-by-address',
    GOOGLE_MAPS_API_KEY: 'AIzaSyBgztdn6VyHdBF82tZNlPtfEzeuhoNbW28' // Replace with actual key
  };

  class StockChecker {
    constructor() {
      this.modal = null;
      this.currentSku = null;
      this.currentProduct = null;
      this.autocomplete = null;
      this.regions = [];
      this.enterTrapSet = false;
      this.autocompleteService = null;
      this.searchDebounceTimer = null;

      // Track last search to enable auto-refresh on variant change
      this.lastRegionId = null;
      this.lastLocation = null; // {lat, lng}
      this.lastRegionSku = null;
      this.lastLocationSku = null;

      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      console.log('Stock Checker: Initializing...');
      this.modal = document.getElementById('stock-checker-modal');

      if (!this.modal) {
        console.error('Stock Checker: Modal element not found!');
        return;
      }

      // Move modal to just before </body> to avoid z-index stacking-context
      // and overflow:hidden issues from parent containers
      if (this.modal.parentNode !== document.body) {
        document.body.appendChild(this.modal);
        console.log('Stock Checker: Modal moved to document.body');
      }

      this.setupEventListeners();
      this.loadRegions();
      this.loadGoogleMapsAPI();
      this.setupSwipeGesture();
      console.log('Stock Checker: Initialized successfully');
    }

    setupEventListeners() {
      // Global Enter key trap for the entire modal - prevents form submission
      const modalContent = this.modal.querySelector('.stock-modal-content');
      if (modalContent && !this.enterTrapSet) {
        modalContent.addEventListener('keydown', (e) => {
          if ((e.key === 'Enter' || e.keyCode === 13) && e.target.tagName === 'INPUT') {
            console.log('Global Enter trap activated for input:', e.target.id);
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true); // Use capture phase to catch it before other handlers
        this.enterTrapSet = true;
        console.log('Global Enter key trap installed');
      }

      // Close modal
      const closeBtn = this.modal.querySelector('.stock-modal-close');
      const overlay = this.modal.querySelector('.stock-modal-overlay');

      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (overlay) overlay.addEventListener('click', () => this.close());

      // Tab switching
      this.modal.querySelectorAll('.stock-tab').forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          // After (works regardless of translation wrappers):
          const tabName = e.currentTarget.dataset.tab || e.target.closest('[data-tab]')?.dataset.tab;
          if (tabName) this.switchTab(tabName);
        });
      });

      // Region search input
      const regionInput = document.getElementById('region-input');
      const regionDropdown = document.getElementById('region-dropdown');

      if (regionInput) {
        // Prevent form submission on Enter
        regionInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        });

        // Toggle dropdown on click (since it's readonly)
        regionInput.addEventListener('click', () => {
          // Check if dropdown is currently visible
          const isVisible = regionDropdown && regionDropdown.style.display === 'block';

          if (isVisible) {
            // Close the dropdown if it's open
            regionDropdown.style.display = 'none';
          } else {
            // Open the dropdown if it's closed
            if (this.regions.length > 0) {
              this.showRegionDropdown();
            } else {
              this.loadRegions().then(() => this.showRegionDropdown());
            }
          }
        });

        // Filter regions on input (if we decide to make it editable later)
        regionInput.addEventListener('input', (e) => {
          this.filterRegions(e.target.value);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (!regionInput.contains(e.target) && !regionDropdown.contains(e.target)) {
            regionDropdown.style.display = 'none';
          }
        });
      }

      // Location input
      const locationInput = document.getElementById('location-input');
      if (locationInput) {
        locationInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        });

        locationInput.addEventListener('input', (e) => {
          const value = e.target.value.trim();
          this.debounceSearch(value);
        });
      }

      // LOCATE ME button
      const locateMeBtn = document.getElementById('locate-me-btn');
      if (locateMeBtn) {
        locateMeBtn.addEventListener('click', () => {
          if (!navigator.geolocation) {
            alert('Geolocation is not supported by your browser');
            return;
          }

          const locateMeLabel = locateMeBtn.querySelector('.locate-me-label');
        //  if (locateMeLabel) locateMeLabel.textContent = 'LOCATING...';
          locateMeBtn.disabled = true;

          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;

              // Fetch stores by location
              this.fetchStockByLocation(lat, lng);

              // Reverse geocode to get address
              try {
                const address = await this.reverseGeocode(lat, lng);
                const locationInput = document.getElementById('location-input');
                if (locationInput) {
                  locationInput.value = address;
                }
              } catch (error) {
                console.error('Reverse geocoding error:', error);
                // Fallback to coordinates if geocoding fails
                const locationInput = document.getElementById('location-input');
                if (locationInput) {
                  locationInput.value = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
                }
              }

          //    if (locateMeLabel) locateMeLabel.textContent = 'LOCATE ME';
              locateMeBtn.disabled = false;
            },
            (error) => {
              console.error('Geolocation error:', error);
              alert('Unable to retrieve your location. Please enter your address manually.');
            //  if (locateMeLabel) locateMeLabel.textContent = 'LOCATE ME';
              locateMeBtn.disabled = false;
            }
          );
        });
      }

      // Back button
      const backBtn = document.getElementById('back-to-results');
      if (backBtn) {
        backBtn.addEventListener('click', () => {
          document.getElementById('store-details').style.display = 'none';
          document.querySelector('.stock-tab-content').style.display = 'block';
        });
      }

      // Tab navigation buttons
      this.setupTabNavigation();
    }

    setupSwipeGesture() {
      // Attach swipe detection to the modal content once — works regardless of tabNavInitialized guard
      const swipeTarget = this.modal.querySelector('.stock-modal-content');
      if (!swipeTarget) return;

      let startX = 0;
      let startY = 0;

      swipeTarget.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      swipeTarget.addEventListener('touchend', (e) => {
        const deltaX = startX - e.changedTouches[0].clientX;
        const deltaY = startY - e.changedTouches[0].clientY;

        // Must be a clear horizontal swipe: at least 30px horizontal,
        // and horizontal distance must be larger than vertical distance
        if (Math.abs(deltaX) < 30) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        const tabs = ['region', 'location'];
        const activeTab = this.modal.querySelector('.stock-tab.active');
        const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;

        if (deltaX > 0) {
          // Swiped LEFT → next tab (location)
          const next = Math.min(currentIndex + 1, tabs.length - 1);
          if (next !== currentIndex) this.switchTab(tabs[next]);
        } else {
          // Swiped RIGHT → previous tab (region)
          const prev = Math.max(currentIndex - 1, 0);
          if (prev !== currentIndex) this.switchTab(tabs[prev]);
        }
      }, { passive: true });
    }

    setupTabNavigation() {
      const tabsContainer = this.modal.querySelector('.stock-tabs');
      const prevBtn = this.modal.querySelector('.tab-nav-prev');
      const nextBtn = this.modal.querySelector('.tab-nav-next');

      if (!tabsContainer || !prevBtn || !nextBtn) {
        console.log('Tab navigation elements not found');
        return;
      }

      // Check if already initialized
      if (this.tabNavInitialized) {
        // Just update button states
        this.updateTabButtonStates();
        return;
      }

      const tabs = ['region', 'location'];

      // Previous button click → switch to previous tab
      prevBtn.addEventListener('click', () => {
        const activeTab = this.modal.querySelector('.stock-tab.active');
        const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;
        const prev = Math.max(currentIndex - 1, 0);
        if (prev !== currentIndex) this.switchTab(tabs[prev]);
      });

      // Next button click → switch to next tab
      nextBtn.addEventListener('click', () => {
        const activeTab = this.modal.querySelector('.stock-tab.active');
        const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;
        const next = Math.min(currentIndex + 1, tabs.length - 1);
        if (next !== currentIndex) this.switchTab(tabs[next]);
      });

      // Mark as initialized
      this.tabNavInitialized = true;

      // Initial state - use setTimeout to ensure DOM is fully rendered
      setTimeout(() => this.updateTabButtonStates(), 100);
    }

    updateTabButtonStates() {
      const tabsContainer = this.modal.querySelector('.stock-tabs');
      const prevBtn = this.modal.querySelector('.tab-nav-prev');
      const nextBtn = this.modal.querySelector('.tab-nav-next');

      if (!tabsContainer || !prevBtn || !nextBtn) return;

      const tabs = ['region', 'location'];
      const activeTab = this.modal.querySelector('.stock-tab.active');
      const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;

      // Disable prev button if on the first tab
      prevBtn.disabled = currentIndex <= 0;

      // Disable next button if on the last tab
      nextBtn.disabled = currentIndex >= tabs.length - 1;

      console.log('Button states updated:', {
        currentIndex,
        prevDisabled: prevBtn.disabled,
        nextDisabled: nextBtn.disabled
      });
    }

    async reverseGeocode(lat, lng) {
      // Try using Google Maps Geocoder SDK first if available
      if (typeof google !== 'undefined' && google.maps && google.maps.Geocoder) {
        try {
          const geocoder = new google.maps.Geocoder();
          const response = await geocoder.geocode({ location: { lat, lng } });

          if (response.results && response.results.length > 0) {
            return response.results[0].formatted_address;
          }
        } catch (error) {
          console.error('Google Maps Geocoder error:', error);
        }
      }

      // Fallback to direct API call
      if (!API_CONFIG.GOOGLE_MAPS_API_KEY || API_CONFIG.GOOGLE_MAPS_API_KEY.includes('YOUR_')) {
        return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      }

      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_CONFIG.GOOGLE_MAPS_API_KEY}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'OK' && data.results && data.results.length > 0) {
          return data.results[0].formatted_address;
        }
        return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      } catch (error) {
        console.error('Geocoding API error:', error);
        throw error;
      }
    }

    async loadRegions() {
      try {
        console.log('Loading regions from API...');
        const response = await fetch(API_CONFIG.REGIONS_URL, {
          headers: {
            'Authorization': API_CONFIG.BEARER_TOKEN,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Regions loaded:', data);

        this.regions = data.regions || data || [];
        console.log(`Loaded ${this.regions.length} regions`);

      } catch (error) {
        console.error('Error loading regions:', error);
        this.regions = [];
      }
    }

    showRegionDropdown(filteredRegions = null) {
      const dropdown = document.getElementById('region-dropdown');
      if (!dropdown) return;

      const regionsToShow = filteredRegions || this.regions;

      if (regionsToShow.length === 0) {
        dropdown.innerHTML = '<div class="region-item" style="color: #999;">No regions found</div>';
        dropdown.style.display = 'block';
        return;
      }

      // Create region items (no placeholder in dropdown)
      dropdown.innerHTML = regionsToShow.map(region => {
        const regionId = region.id || region.region_id;
        const regionName = region.name || region.region_name;

        // Add 'selected' class if this is the currently selected region
        const isSelected = this.selectedRegionId && this.selectedRegionId == regionId;
        const selectedClass = isSelected ? ' selected' : '';

        return `<div class="region-item${selectedClass}" data-region-id="${regionId}" data-region-name="${regionName}">${regionName}</div>`;
      }).join('');

      // Add click handlers
      dropdown.querySelectorAll('.region-item').forEach(item => {
        item.addEventListener('click', () => {
          const regionId = item.dataset.regionId;
          const regionName = item.dataset.regionName;

          if (regionId) {
            // Store the selected region ID
            this.selectedRegionId = regionId;

            document.getElementById('region-input').value = regionName;
            dropdown.style.display = 'none';
            this.fetchStockByRegion(regionId);
          }
        });
      });

      dropdown.style.display = 'block';
    }

    filterRegions(searchTerm) {
      const dropdown = document.getElementById('region-dropdown');
      if (!dropdown) return;

      if (!searchTerm || searchTerm.trim() === '') {
        this.showRegionDropdown();
        return;
      }

      const filtered = this.regions.filter(region => {
        const regionName = (region.name || region.region_name || '').toLowerCase();
        return regionName.includes(searchTerm.toLowerCase());
      });

      this.showRegionDropdown(filtered);
    }

    setupStoreSearch(container) {
      const isRegionTab = container.id === 'region-results';
      const searchInputId = isRegionTab ? 'store-search-input' : 'location-store-search-input';
      const searchInput = document.getElementById(searchInputId);

      console.log(`[setupStoreSearch] Called for container: ${container.id}`);
      console.log(`[setupStoreSearch] Looking for input: ${searchInputId}`);
      console.log(`[setupStoreSearch] Input found:`, !!searchInput);

      if (!searchInput) {
        console.error(`[setupStoreSearch] ERROR: Search input ${searchInputId} not found!`);
        return;
      }

      // Check if already has listener
      const hasListener = searchInput.dataset.listenerAttached === 'true';
      console.log(`[setupStoreSearch] Listener already attached:`, hasListener);

      if (hasListener) {
        console.log(`[setupStoreSearch] Skipping - listener already attached to ${searchInputId}`);
        return;
      }

      // Mark as having listener BEFORE attaching to avoid race conditions
      searchInput.dataset.listenerAttached = 'true';
      console.log(`[setupStoreSearch] Marked ${searchInputId} as having listener`);

      // Prevent form submission on Enter
      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
          console.log(`[setupStoreSearch] Enter key pressed in ${searchInputId}`);
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }, true);

      console.log(`[setupStoreSearch] Attached keydown listener to ${searchInputId}`);

      // Search functionality
      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();
        console.log(`[Search] Input event fired for ${searchInputId}`);
        console.log(`[Search] Search term: "${searchTerm}"`);
        console.log(`[Search] Container: ${container.id}`);

        let hasVisibleStores = false;
        const groups = container.querySelectorAll('.store-group');

        console.log(`[Search] Found ${groups.length} store groups in ${container.id}`);

        if (groups.length === 0) {
          console.warn(`[Search] WARNING: No store groups found in ${container.id}!`);
        }

        groups.forEach((group, index) => {
          const regionName = (group.dataset.region || '').toLowerCase();
          const storeName = group.querySelector('.store-details-panel h4')?.textContent.toLowerCase() || '';

          const matches = searchTerm === '' || regionName.includes(searchTerm) || storeName.includes(searchTerm);

          console.log(`[Search] Group ${index}: region="${regionName}", store="${storeName}", matches=${matches}`);

          if (matches) {
            group.style.display = '';
            hasVisibleStores = true;
          } else {
            group.style.display = 'none';
            group.classList.remove('expanded');
          }
        });

        console.log(`[Search] Has visible stores: ${hasVisibleStores}`);

        // Show/hide no results message
        let noResultsMsg = container.querySelector('.no-results-message-search');

        if (!hasVisibleStores && searchTerm !== '') {
          console.log(`[Search] Showing "No Store Found" message`);
          if (!noResultsMsg) {
            noResultsMsg = document.createElement('div');
            noResultsMsg.className = 'no-results-message no-results-message-search';
            noResultsMsg.textContent = 'No Store Found';
            noResultsMsg.style.textAlign = 'center';
            noResultsMsg.style.padding = '20px';
            noResultsMsg.style.color = '#666';
            noResultsMsg.style.fontSize = '14px';
            container.appendChild(noResultsMsg);
          }
          noResultsMsg.style.display = 'block';
        } else if (noResultsMsg) {
          noResultsMsg.style.display = 'none';
        }
      });

      console.log(`[setupStoreSearch] ✓ Search setup complete for ${searchInputId}`);
      console.log(`[setupStoreSearch] ✓ Input listener attached, test by typing in the search box`);
    }

    loadGoogleMapsAPI() {
      // Check if Google Maps is already loaded
      if (typeof google !== 'undefined' && google.maps) {
        this.initAutocomplete();
        return;
      }

      // Check if script is already being loaded
      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api"]');
      if (existingScript) {
        // Script is already loading/loaded — wait for places library to be ready
        const waitForPlaces = () => {
          if (typeof google !== 'undefined' && google.maps && google.maps.places && google.maps.places.Autocomplete) {
            this.initAutocomplete();
          } else if (typeof google !== 'undefined' && google.maps && google.maps.importLibrary) {
            google.maps.importLibrary('places').then(() => this.initAutocomplete());
          } else {
            setTimeout(waitForPlaces, 50);
          }
        };
        waitForPlaces();
        return;
      }

      // Create and load the script
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API_CONFIG.GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // With loading=async the places library may not be ready immediately;
        // use importLibrary when available, otherwise poll until ready.
        if (google.maps.importLibrary) {
          google.maps.importLibrary('places').then(() => this.initAutocomplete());
        } else {
          const wait = setInterval(() => {
            if (google.maps.places && google.maps.places.Autocomplete) {
              clearInterval(wait);
              this.initAutocomplete();
            }
          }, 50);
        }
      };
      document.head.appendChild(script);
    }

    initAutocomplete() {
      const input = document.getElementById('location-input');
      if (!input || typeof google === 'undefined') return;

      this.autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'nz' },
        fields: ['geometry', 'formatted_address'],
      });

      this.autocompleteService = new google.maps.places.AutocompleteService();

      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          this.fetchStockByLocation(lat, lng);
          // Clear any error message when a valid place is selected
          const resultsContainer = document.getElementById('location-results');
          if (resultsContainer && resultsContainer.querySelector('.no-results-message')) {
            resultsContainer.innerHTML = '';
          }
        } else {
          // Show error message for invalid input
          const resultsContainer = document.getElementById('location-results');
          if (resultsContainer) {
            resultsContainer.innerHTML = `
              <div class="no-results-message">
                No Details available for input: ${input.value}. Please select suggested input!
              </div>
            `;
          }
        }
      });

   const inputParent = input.closest('.location-input-main');
      if (inputParent) {
        inputParent.style.position = 'relative'; // Ensure parent is relative for absolute positioning
        
        // ✅ FIX: Only capture pac-containers when the modal is OPEN
        // This prevents stealing pac-containers from PDP Click & Collect or Cart autocompletes
        // while still maintaining sticky behavior when scrolling inside the modal
        const modal = this.modal;
        
        // Helper function to check if modal is actually visible
        const isModalOpen = () => {
          if (!modal) return false;
          // Check inline style first (most reliable after open() is called)
          if (modal.style.display === 'block') return true;
          // Check computed style as fallback
          const computedStyle = window.getComputedStyle(modal);
          return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden';
        };
        
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.classList && node.classList.contains('pac-container')) {
                // ✅ CRITICAL: Only capture if modal is OPEN
                if (!isModalOpen()) {
                  console.log('[Stock Checker Modal] ⚠️ pac-container detected but modal is CLOSED - IGNORING');
                  return;
                }
                
                // Check if this pac-container is already inside our inputParent (avoid moving it again)
                if (node.parentElement === inputParent) {
                  console.log('[Stock Checker Modal] pac-container already in inputParent - skipping');
                  return;
                }
                
                console.log('[Stock Checker Modal] ✅ CAPTURING pac-container for modal (modal is open)');
                inputParent.appendChild(node);
              }
            });
          });
        });
        observer.observe(document.body, { childList: true });
        console.log('[Stock Checker Modal] MutationObserver initialized');
      }
    
    }

    debounceSearch(value) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      if (!value) {
        const resultsContainer = document.getElementById('location-results');
        if (resultsContainer && resultsContainer.querySelector('.no-results-message')) {
          resultsContainer.innerHTML = '';
        }
        return;
      }

      this.searchDebounceTimer = setTimeout(() => {
        this.checkPredictions(value);
      }, 500);
    }

    checkPredictions(value) {
      if (!this.autocompleteService) return;

      this.autocompleteService.getPlacePredictions({
        input: value,
        componentRestrictions: { country: 'nz' }
      }, (predictions, status) => {
        const resultsContainer = document.getElementById('location-results');
        if (!resultsContainer) return;

        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions || predictions.length === 0) {
          resultsContainer.innerHTML = `
            <div class="no-results-message">
              No Details available for input: ${value}. Please select suggested input!
            </div>
          `;
        } else {
          // Clear error message if predictions are found
          if (resultsContainer.querySelector('.no-results-message')) {
            resultsContainer.innerHTML = '';
          }
        }
      });
    }

    open(productData, variantId) {
      console.log('Stock Checker: Opening modal', productData);

      if (!productData) {
        console.error('Stock Checker: No product data provided');
        return;
      }

      this.currentProduct = productData;

      // Set product image
      const imgEl = document.getElementById('stock-product-image');
      if (imgEl && productData.featured_image) {
        imgEl.src = productData.featured_image;
        imgEl.alt = productData.title || '';
      }

      // Set product title
      const titleEl = document.getElementById('stock-product-title');
      if (titleEl) {
        titleEl.textContent = productData.title || '';
      }

      // Setup variant selector
      this.setupVariantSelector(productData, variantId);

      // Show modal
      this.modal.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // ✅ Capture any existing pac-container when modal opens
      this.captureExistingPacContainer();

      // Setup tab navigation after modal is visible
      this.setupTabNavigation();
    }

    // Helper method to capture existing pac-containers for sticky behavior
    captureExistingPacContainer() {
      const inputParent = document.querySelector('#location-input')?.closest('.location-input-main');
      if (!inputParent) return;
      
      // Find all pac-containers in body that are NOT already in inputParent
      const pacContainers = document.querySelectorAll('body > .pac-container');
      pacContainers.forEach(pac => {
        console.log('[Stock Checker Modal] ✅ Capturing existing pac-container on modal open');
        inputParent.appendChild(pac);
      });
    }

    close() {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      this.resetModal();
    }

    resetModal() {
      const regionResults = document.getElementById('region-results');
      const locationResults = document.getElementById('location-results');
      const locationInput = document.getElementById('location-input');
      const regionInput = document.getElementById('region-input');
      const regionDropdown = document.getElementById('region-dropdown');
      const storeDetails = document.getElementById('store-details');
      const tabContent = document.querySelector('.stock-tab-content');

      // Clear search inputs
      const storeSearchInput = document.getElementById('store-search-input');
      const locationStoreSearchInput = document.getElementById('location-store-search-input');

      // Hide stores headers
      const regionHeader = document.querySelector('#region-tab .stores-header');
      const locationHeader = document.querySelector('#location-tab .stores-header');

      if (regionResults) regionResults.innerHTML = '';
      if (locationResults) locationResults.innerHTML = '';
      if (locationInput) locationInput.value = '';
      if (regionInput) regionInput.value = '';
      if (regionDropdown) regionDropdown.style.display = 'none';
      if (storeDetails) storeDetails.style.display = 'none';
      if (tabContent) tabContent.style.display = 'block';

      // Clear search inputs
      if (storeSearchInput) storeSearchInput.value = '';
      if (locationStoreSearchInput) locationStoreSearchInput.value = '';

      // Hide headers
      if (regionHeader) regionHeader.style.display = 'none';
      if (locationHeader) locationHeader.style.display = 'none';

      // Clear last search tracking
      this.lastRegionId = null;
      this.lastLocation = null;
      this.lastRegionSku = null;
      this.lastLocationSku = null;
    }

    setupVariantSelector(product, selectedVariantId) {
      const container = document.getElementById('stock-variant-selector');
      if (!container) return;

      if (!product.variants || product.variants.length <= 1) {
        this.currentSku = product.variants && product.variants[0] ? product.variants[0].sku : '';
        container.innerHTML = '';
        return;
      }

      container.innerHTML = '';
      const variantWrapper = document.createElement('div');
      variantWrapper.className = 'variant-selector-wrapper';

      // Track selected options
      const selectedVariant = product.variants.find(v => v.id == selectedVariantId) || product.variants[0];
      const selectedOptions = {
        option1: selectedVariant.option1,
        option2: selectedVariant.option2,
        option3: selectedVariant.option3
      };

      // Helper to update everything when an option changes
      const refreshVariant = () => {
        const matchedVariant = product.variants.find(v =>
          v.option1 === selectedOptions.option1 &&
          (product.options.length < 2 || v.option2 === selectedOptions.option2) &&
          (product.options.length < 3 || v.option3 === selectedOptions.option3)
        );

        if (matchedVariant) {
          this.currentSku = matchedVariant.sku;

          // Update product image
          const imgEl = document.getElementById('stock-product-image');
          const variantImage = matchedVariant.featured_image || product.featured_image;
          if (imgEl && variantImage) {
            imgEl.src = variantImage;
          }

          // Update all labels and swatch selections
          product.options.forEach((optionName, index) => {
            const optionKey = `option${index + 1}`;
            const selectedValue = selectedOptions[optionKey];

            // Update label value
            const labelValEl = document.querySelector(`.variant-selected-value[data-option-index="${index}"]`);
            if (labelValEl) {
              labelValEl.textContent = selectedValue;
            }

            // Update swatch active state
            const swatches = document.querySelectorAll(`.variant-swatch[data-option-index="${index}"]`);
            swatches.forEach(swatch => {
              swatch.classList.toggle('selected', swatch.dataset.value === selectedValue);
            });
          });

          // Auto-refresh stock data if user had previously searched
          const activeTab = this.modal.querySelector('.stock-tab.active')?.dataset.tab;
          if (activeTab === 'region' && this.lastRegionId) {
            this.fetchStockByRegion(this.lastRegionId);
          } else if (activeTab === 'location' && this.lastLocation) {
            this.fetchStockByLocation(this.lastLocation.lat, this.lastLocation.lng);
          }
        }
      };

      // Render each option row
      product.options.forEach((optionName, index) => {
        const optionKey = `option${index + 1}`;
        const optionRow = document.createElement('div');
        optionRow.className = 'variant-option-row';
        optionRow.style.marginBottom = '1.5rem';

        // Label
        const label = document.createElement('div');
        label.className = 'variant-label';
        label.innerHTML = `${optionName} <span class="variant-label-asterisk">:</span> <span class="variant-selected-value" data-option-index="${index}">${selectedOptions[optionKey]}</span>`;
        optionRow.appendChild(label);

        // Swatches container
        const swatchesContainer = document.createElement('div');
        swatchesContainer.className = 'variant-swatches';

        const isColorOption = /colou?r/i.test(optionName);

        // Add this line — extra class if NOT color variant
        if (!isColorOption) {
          swatchesContainer.classList.add('non-color-variant');
        }
        // Get unique values for this option
        const uniqueValues = [...new Set(product.variants.map(v => v[optionKey]))].filter(Boolean);

        // Check if any variant for this color option has a variant-specific image
        // Compare each variant's image against the product's main image
        // Strip query params to avoid false negatives from URL param differences
        let hasAnyVariantImage = false;
        if (isColorOption) {
          const getImagePath = (url) => url ? url.split('?')[0].trim() : '';
          const productImagePath = getImagePath(product.featured_image);

          hasAnyVariantImage = uniqueValues.some(value => {
            const v = product.variants.find(vr => vr[optionKey] === value);
            if (!v || !v.featured_image) return false;
            return getImagePath(v.featured_image) !== productImagePath;
          });

          // Debug logging - can be removed after confirming fix
          if (!hasAnyVariantImage) {
            console.log('Stock Checker: No variant-specific images detected for', optionName, {
              productImage: product.featured_image,
              variantImages: uniqueValues.map(val => {
                const v = product.variants.find(vr => vr[optionKey] === val);
                return { value: val, image: v ? v.featured_image : null };
              })
            });
          }
        }

        // If color option has variant images, use image swatches
        if (isColorOption && hasAnyVariantImage) {
          swatchesContainer.classList.add('variant-swatches--images');
        }

        uniqueValues.forEach(value => {
          const swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'variant-swatch';
          swatch.dataset.optionIndex = index;
          swatch.dataset.value = value;

          // For color options with variant images, show image; otherwise show text label
          if (isColorOption && hasAnyVariantImage) {
            const variantForValue = product.variants.find(v => v[optionKey] === value && v.featured_image);
            if (variantForValue && variantForValue.featured_image) {
              const img = document.createElement('img');
              img.src = variantForValue.featured_image;
              img.alt = value;
              img.className = 'variant-swatch-img';
              swatch.appendChild(img);
              swatch.classList.add('variant-swatch--image');
              swatch.title = value;
            } else {
              swatch.textContent = value;
            }
          } else {
            swatch.textContent = value;
          }

          if (value === selectedOptions[optionKey]) {
            swatch.classList.add('selected');
          }

          swatch.addEventListener('click', (e) => {
            e.preventDefault();
            selectedOptions[optionKey] = value;
            refreshVariant();
          });

          swatchesContainer.appendChild(swatch);
        });

        optionRow.appendChild(swatchesContainer);
        variantWrapper.appendChild(optionRow);
      });

      container.appendChild(variantWrapper);

      // Initial SKU set
      this.currentSku = selectedVariant.sku;
       refreshVariant();
    }

    switchTab(tabName) {
      this.modal.querySelectorAll('.stock-tab').forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.tab === tabName);
      });

      this.modal.querySelectorAll('.tab-panel').forEach((panel) => {
        panel.classList.toggle('active', panel.id === `${tabName}-tab`);
      });

      // Update arrow button disabled states to reflect new active tab
      this.updateTabButtonStates();

      // Refresh stock if variant has changed since last fetch for this tab
      if (tabName === 'region' && this.lastRegionId && this.currentSku !== this.lastRegionSku) {
        console.log('Refreshing region stock on tab switch...');
        this.fetchStockByRegion(this.lastRegionId);
      } else if (tabName === 'location' && this.lastLocation && this.currentSku !== this.lastLocationSku) {
        console.log('Refreshing location stock on tab switch...');
        this.fetchStockByLocation(this.lastLocation.lat, this.lastLocation.lng);
      }
    }

    async fetchStockByRegion(regionId) {
      if (!this.currentSku) {
        alert('Something went wrong.');
        return;
      }

      // Prevent redundant API calls if region and SKU are the same
      if (this.lastRegionId === regionId && this.lastRegionSku === this.currentSku) {
        console.log('Region and SKU are same, skipping API call');
        return;
      }

      const resultsContainer = document.getElementById('region-results');
      resultsContainer.innerHTML = '<div class="loading">Loading stores...</div>';

      // Clear the search input when selecting a new region
      const searchInput = document.getElementById('store-search-input');
      if (searchInput) {
        searchInput.value = '';
      }

      // Save last search for auto-refresh on variant change
      this.lastRegionId = regionId;
      this.lastRegionSku = this.currentSku;
      // DO NOT clear lastLocation here to allow switching back and forth

      try {
        const url = `${API_CONFIG.STOCK_BY_REGION_URL}?sku=${encodeURIComponent(
          this.currentSku
        )}&region_id=${encodeURIComponent(regionId)}`;

        console.log('=== Stock API Request ===');
        console.log('URL:', url);
        console.log('SKU:', this.currentSku);
        console.log('Region ID:', regionId);
        console.log('Bearer Token:', API_CONFIG.BEARER_TOKEN.substring(0, 20) + '...');

        const response = await fetch(url, {
          headers: {
            'Authorization': API_CONFIG.BEARER_TOKEN,
            'Content-Type': 'application/json'
          }
        });

        console.log('=== Stock API Response ===');
        console.log('Status:', response.status);
        console.log('Status Text:', response.statusText);
        console.log('Headers:', Object.fromEntries(response.headers.entries()));

        if (!response.ok) {
          // Try to get error details from response body
          let errorDetails = '';
          try {
            const errorText = await response.text();
            console.error('Error Response Body:', errorText);
            errorDetails = errorText ? `\n\nServer response: ${errorText.substring(0, 200)}` : '';
          } catch (e) {
            console.error('Could not read error response:', e);
          }

          throw new Error(`HTTP error! status: ${response.status}${errorDetails}`);
        }

        const data = await response.json();
        console.log('Region stock data:', data);

        // Parse inventory array from response
        const stores = data.inventory || [];
        this.renderStoreList(stores, resultsContainer);
      } catch (error) {
        console.error('=== Stock Fetch Error ===');
        console.error('Error:', error);
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);

        resultsContainer.innerHTML = `
            <div class="error-message">
              <strong>Error loading stores</strong><br>
            </div>
          `;
      }
    }

    async fetchStockByLocation(lat, lng) {
      if (!this.currentSku) {
        alert('Something went wrong.');
        return;
      }

      // Prevent redundant API calls if location and SKU are the same
      if (this.lastLocation &&
        this.lastLocation.lat === lat &&
        this.lastLocation.lng === lng &&
        this.lastLocationSku === this.currentSku) {
        console.log('Location and SKU are same, skipping API call');
        return;
      }

      const resultsContainer = document.getElementById('location-results');
      resultsContainer.innerHTML = '<div class="loading">Finding nearby stores...</div>';

      // Clear the search input when selecting a new location
      const searchInput = document.getElementById('location-store-search-input');
      if (searchInput) {
        searchInput.value = '';
      }

      // Save last search for auto-refresh on variant change
      this.lastLocation = { lat, lng };
      this.lastLocationSku = this.currentSku;
      // DO NOT clear lastRegionId here to allow switching back and forth

      try {
        const url = `${API_CONFIG.STOCK_BY_LOCATION_URL}?sku=${encodeURIComponent(
          this.currentSku
        )}&lat=${lat}&lng=${lng}`;

        console.log('=== Location Stock API Request ===');
        console.log('URL:', url);
        console.log('SKU:', this.currentSku);
        console.log('Latitude:', lat);
        console.log('Longitude:', lng);

        const response = await fetch(url, {
          headers: {
            'Authorization': API_CONFIG.BEARER_TOKEN,
            'Content-Type': 'application/json'
          }
        });

        console.log('=== Location Stock API Response ===');
        console.log('Status:', response.status);
        console.log('Status Text:', response.statusText);

        if (!response.ok) {
          // Try to get error details from response body
          let errorDetails = '';
          try {
            const errorText = await response.text();
            console.error('Error Response Body:', errorText);
            errorDetails = errorText ? `\n\nServer response: ${errorText.substring(0, 200)}` : '';
          } catch (e) {
            console.error('Could not read error response:', e);
          }

          throw new Error(`HTTP error! status: ${response.status}${errorDetails}`);
        }

        const data = await response.json();
        console.log('Location stock data:', data);

        // Parse inventory array from response
        const stores = data.inventory || [];
        this.renderStoreList(stores, resultsContainer);
      } catch (error) {
        console.error('=== Location Stock Fetch Error ===');
        console.error('Error:', error);
        console.error('Error message:', error.message);

        resultsContainer.innerHTML = `
            <div class="error-message">
              <strong>Error loading stores</strong><br>
            </div>
          `;
      }
    }

    renderStoreList(stores, container) {
      // Show/hide header based on results
      const isRegionTab = container.id === 'region-results';
      const headerSelector = isRegionTab ? '#region-tab .stores-header' : '#location-tab .stores-header';
      const header = document.querySelector(headerSelector);

      if (!stores || stores.length === 0) {
        container.innerHTML = '<div class="no-results-message">No Store Found</div>';
        if (header) header.style.display = 'none';
        return;
      }

      if (header) header.style.display = 'flex';

      // Group stores by region/area (extract from outlet_name)
      const storeGroups = {};
      stores.forEach(store => {
        // Extract region from store name (e.g., "Shosha Albany" -> "Albany")
        const storeName = store.outlet_name || 'Store';
        const region = storeName.replace(/^Shosha\s+/i, '').trim() || 'Other';

        if (!storeGroups[region]) {
          storeGroups[region] = [];
        }
        storeGroups[region].push(store);
      });

      // Render store groups
      const groupsHTML = Object.entries(storeGroups).map(([region, regionStores]) => {
        const totalStock = regionStores.reduce((sum, store) => sum + (store.inventory || 0), 0);

        // Get first store for details (assuming one store per region for now)
        const store = regionStores[0];

        // Format hours
        let hoursHTML = '';
        if (store.details && store.details.hours && Array.isArray(store.details.hours)) {
          hoursHTML = store.details.hours.map(dayObj => {
            const dayName = Object.keys(dayObj)[0];
            const times = dayObj[dayName];
            const formattedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1);

            if (times.open === 'CLOSED' || times.closed === 'CLOSED') {
              return `
                  <div class="day-name">${formattedDay}</div>
                  <div class="day-hours">Closed</div>
                `;
            }

            return `
                <div class="day-name">${formattedDay}</div>
                <div class="day-hours">${times.open} - ${times.closed}</div>
              `;
          }).join('');
        }

        return `
            <div class="store-group" data-region="${this.escapeHtml(region)}">
              <div class="store-group-header">
                <div class="store-group-name">${this.escapeHtml(region)}</div>
                <div class="store-group-meta">
                  <div class="store-stock-count">Stock: <span>${totalStock}</span></div>
                  <span class="expand-icon"></span>
                </div>
              </div>
              
              <div class="store-details-panel">
               
                
                <div class="store-details-content-wrapper">
                  <div class="store-info-col">
                   <h4>${this.escapeHtml(store.outlet_name || region)}</h4>
                    ${store.details && store.details.address ? `
                      <div class="store-detail-row">
                        <div class="store-detail-label">Address:</div>
                        <div class="store-detail-value">${this.escapeHtml(store.details.address)}</div>
                      </div>
                    ` : ''}
                    
                    ${store.details && store.details.phone ? `
                      <div class="store-detail-row">
                        <div class="store-detail-label">Phone:</div>
                        <div class="store-detail-value">${this.escapeHtml(store.details.phone)}</div>
                      </div>
                    ` : ''}
                  </div>
                  
                  <div class="store-hours-col">
                    ${hoursHTML ? `
                      <div class="store-hours-grid">
                        ${hoursHTML}
                      </div>
                    ` : ''}
                  </div>
                </div>
              </div>
            </div>
          `;
      }).join('');

      container.innerHTML = groupsHTML;

      // Add click listeners for expand/collapse
      container.querySelectorAll('.store-group-header').forEach((header) => {
        header.addEventListener('click', () => {
          const group = header.parentElement;


          // Toggle current group
          group.classList.toggle('expanded');
        });
      });

      // Setup store search functionality
      this.setupStoreSearch(container);
    }


    showStoreDetails(store) {
      const detailsContainer = document.getElementById('store-details-content');

      // Format hours from API response structure
      let hoursHTML = '';
      if (store.details && store.details.hours) {
        hoursHTML = `
          <div class="store-detail-item">
            <span class="store-detail-label">Opening Hours:</span>
            <div class="store-hours">${this.formatHours(store.details.hours)}</div>
          </div>
        `;
      }

      detailsContainer.innerHTML = `
        <h3>${this.escapeHtml(store.outlet_name || 'Store')}</h3>
        
        ${store.details && store.details.address
          ? `
          <div class="store-detail-item">
            <span class="store-detail-label">Address:</span>
            ${this.escapeHtml(store.details.address)}
          </div>
        `
          : ''
        }
        
        ${store.details && store.details.phone
          ? `
          <div class="store-detail-item">
            <span class="store-detail-label">Phone:</span>
            ${this.escapeHtml(store.details.phone)}
          </div>
        `
          : ''
        }
        
        ${hoursHTML}
        
        <div class="store-detail-item">
          <span class="store-detail-label">Stock Available:</span>
          <span class="store-stock ${store.inventory > 0 ? '' : 'out-of-stock'}">
            ${store.inventory > 0 ? `${store.inventory} units` : 'Out of stock'}
          </span>
        </div>
      `;

      document.querySelector('.stock-tab-content').style.display = 'none';
      document.getElementById('store-details').style.display = 'block';
    }

    formatHours(hours) {
      if (!hours || !Array.isArray(hours)) return 'Contact store for hours';

      return hours.map(dayObj => {
        const dayName = Object.keys(dayObj)[0];
        const times = dayObj[dayName];
        const formattedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1);

        if (times.open === 'CLOSED' || times.closed === 'CLOSED') {
          return `<div><strong>${formattedDay}:</strong> Closed</div>`;
        }

        return `<div><strong>${formattedDay}:</strong> ${times.open} - ${times.closed}</div>`;
      }).join('');
    }

    escapeHtml(text) {
      if (!text) return '';
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  // Initialize and expose globally
  window.stockChecker = new StockChecker();
  console.log('Stock Checker: Available globally as window.stockChecker');
})();
